import { render, staticRenderFns } from "./server.vue?vue&type=template&id=10518554&"
import script from "./server.vue?vue&type=script&lang=js&"
export * from "./server.vue?vue&type=script&lang=js&"
import style0 from "./server.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports